// extracted by mini-css-extract-plugin
module.exports = {"menu":"ShareButton_menu__VmVIr","copied":"ShareButton_copied__oOkYS","button":"ShareButton_button__uGPDL","share_icon":"ShareButton_share_icon__ecC81"};